<template>
  <v-dialog v-model="show" max-width="500px" scrollable>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <h4>Change Request Status</h4>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = false">
            <v-icon>{{ close }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-container class="pa-5">
          <v-textarea
            outlined
            :rules="[v => !!v || 'Reason is required']"
            label="Reason"
            v-model="reason"
            hide-details="auto"
            required
          ></v-textarea>
        </v-container>
        <v-card-actions class="px-10 pb-3">
          <v-btn
            class="text-capitalize"
            block
            color="primary"
            :loading="loading"
            @click="sendReason"
          >
            {{ status }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mdiClose } from '@mdi/js'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      close: mdiClose,
      valid: false,
      reason: null
    }
  },

  mounted() {
    this.reason = null
  },

  methods: {
    sendReason() {
      this.$refs.form.validate()
      if (this.valid) {
        this.show = false
        this.$emit('verify', this.reason)
        this.reason = null
      }
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    }
  }
}
</script>
